import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["domainName", "actionHandler"],
  _excluded2 = ["domainName"],
  _excluded3 = ["actionHandler"],
  _excluded4 = ["actionHandler"],
  _excluded5 = ["domainName", "msid", "actionHandler"];
import { getPremiumEssentials } from '@wix/premium-fed-sdk/@premium-essentials';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { StatusesModule } from './Statuses/StatusesModule';
import { fetchWithFallback } from '@wix/premium-fed-sdk/@apis-infra';
import { domainIsTakenHandler } from './Statuses/DomainSearchErrors';
import { entriConnectAction } from './entriConnectAction';
import { ModalsModule } from '../../ModalsExtensions';
import { urls } from '../../Navigation/urls';
import React from 'react';
import { EntriFlowStatus, parseDomain } from '@wix/domains-serverless-interface';
import { InvalidDomain } from './Statuses/DomainNameErrors/InvalidDomain';
import { DomainSearchSuiteModule } from '../../../domainSearchSuite.module';
import { Specs } from '../../Specs';
const showUpgrade = _ref => {
  let domainName = _ref.domainName,
    siteName = _ref.siteName,
    msid = _ref.msid,
    externalViewer = _ref.externalViewer,
    useUpgradePaywall = _ref.useUpgradePaywall,
    referralAdditionalInfo = _ref.referralAdditionalInfo,
    sameTab = _ref.sameTab;
  const _ModalsModule$interna = ModalsModule.internals.domainsActionsModalsController,
    upgradeRequireConnect = _ModalsModule$interna.upgradeRequireConnect,
    upgradePaywall = _ModalsModule$interna.upgradePaywall,
    upgradePaywallModal = _ModalsModule$interna.upgradePaywallModal;
  const _getPremiumEssentials = getPremiumEssentials(),
    experiments = _getPremiumEssentials.experiments;
  const useUpgradePaywallModal = Boolean(experiments == null ? void 0 : experiments[Specs.UPGRADE_PAYWALL_BM]);
  const forceNewTab = Boolean(experiments == null ? void 0 : experiments[Specs.OPEN_IN_NEW_TAB_BM]) || Boolean(experiments == null ? void 0 : experiments[Specs.WIX_VIBE_OPEN_IN_NEW_TAB]) && Boolean(externalViewer);
  const modal = useUpgradePaywall && upgradePaywall || useUpgradePaywallModal && !useUpgradePaywall && upgradePaywallModal || upgradeRequireConnect;
  const useSelfTab = Boolean(sameTab) && window.self === window.top;
  const target = useSelfTab || useUpgradePaywall && !forceNewTab ? '_self' : '_blank';
  modal.show({
    domainName,
    siteName,
    primaryButtonOnClick() {
      if (!domainName || !msid) {
        return;
      }
      const url = urls.packagePickerUrl({
        domainName,
        metaSiteId: msid,
        referralAdditionalInfo
      });
      window.open(url, target);
    }
  });
};
const upgradeModalAction = params => async () => {
  showUpgrade(params);
};
export const domainSearchErrorStatuses = {
  noStatus: () => ({
    StatusComponent: () => null
  }),
  domainTakenInWix: _ref2 => {
    let msid = _ref2.msid,
      siteName = _ref2.siteName,
      domainName = _ref2.domainName,
      t = _ref2.t,
      externalViewer = _ref2.externalViewer,
      fullPage = _ref2.fullPage,
      actionHandler = _ref2.actionHandler;
    const _getPremiumEssentials2 = getPremiumEssentials(),
      httpClient = _getPremiumEssentials2.httpClient;
    const canChangeOwnerReq = fetchWithFallback(DomainsApiClient.query.canChangeDomainOwner({
      httpClient: httpClient,
      request: {
        domain: domainName
      }
    }), {
      canChangeOwner: false
    });
    canChangeOwnerReq.then(() => {
      DomainsApiClient.query.domainTakenInAnotherAccountEntriEligibility({
        httpClient: httpClient,
        request: {
          domain: domainName
        }
      }).catch(() => {});
    });
    return {
      action: async () => {
        if (!msid) {
          actionHandler == null || actionHandler({
            result: EntriFlowStatus.manual,
            externalViewer,
            domainName
          });
          return;
        }
        const result = await domainIsTakenHandler({
          domainName,
          msid,
          siteName,
          externalViewer,
          fullPage,
          t
        });
        if (result) {
          actionHandler == null || actionHandler({
            result,
            externalViewer,
            domainName
          });
        }
      },
      StatusComponent: StatusesModule.SDK.Components.DomainIsTaken
    };
  },
  subdomainTakenInWix: _ref3 => {
    let domainName = _ref3.domainName,
      msid = _ref3.msid,
      siteName = _ref3.siteName,
      externalViewer = _ref3.externalViewer,
      fullPage = _ref3.fullPage,
      t = _ref3.t,
      actionHandler = _ref3.actionHandler;
    const _getPremiumEssentials3 = getPremiumEssentials(),
      httpClient = _getPremiumEssentials3.httpClient;
    const _parseDomain = parseDomain(domainName),
      rootDomain = _parseDomain.main;
    fetchWithFallback(DomainsApiClient.query.canChangeDomainOwner({
      httpClient: httpClient,
      request: {
        domain: rootDomain
      }
    }), {
      canChangeOwner: false
    }).then(() => {
      DomainsApiClient.query.domainTakenInAnotherAccountEntriEligibility({
        httpClient: httpClient,
        request: {
          domain: rootDomain
        }
      }).catch(() => {});
    });
    return {
      action: async () => {
        if (!msid) {
          actionHandler == null || actionHandler({
            result: EntriFlowStatus.manual,
            externalViewer,
            domainName
          });
          return;
        }
        const result = await domainIsTakenHandler({
          domainName,
          msid,
          siteName,
          externalViewer,
          fullPage,
          t
        });
        if (result) {
          actionHandler == null || actionHandler({
            result,
            externalViewer,
            domainName
          });
        }
      },
      StatusComponent: StatusesModule.SDK.Components.SubdomainRootIsTaken
    };
  },
  subdomainRootIsConnectedByDns: _ref4 => {
    let domainName = _ref4.domainName,
      msid = _ref4.msid,
      siteName = _ref4.siteName,
      externalViewer = _ref4.externalViewer,
      actionHandler = _ref4.actionHandler;
    return {
      action: async () => {
        if (!msid || !siteName) {
          actionHandler == null || actionHandler({
            result: EntriFlowStatus.manual,
            externalViewer,
            domainName
          });
          return;
        }
        actionHandler == null || actionHandler({
          result: EntriFlowStatus.success,
          externalViewer,
          domainName,
          assigningSiteId: msid
        });
      },
      autoInvoke: true
    };
  },
  subdomainRootIsRegistered: _ref5 => {
    let domainName = _ref5.domainName,
      msid = _ref5.msid,
      siteName = _ref5.siteName,
      externalViewer = _ref5.externalViewer,
      actionHandler = _ref5.actionHandler;
    return {
      action: async () => {
        if (!msid || !siteName) {
          actionHandler == null || actionHandler({
            result: EntriFlowStatus.manual,
            externalViewer,
            domainName
          });
          return;
        }
        actionHandler == null || actionHandler({
          result: EntriFlowStatus.success,
          externalViewer,
          domainName,
          assigningSiteId: msid
        });
      },
      autoInvoke: true
    };
  },
  subdomainRootIsNotConnected: _ref6 => {
    let domainName = _ref6.domainName,
      msid = _ref6.msid,
      siteName = _ref6.siteName,
      externalViewer = _ref6.externalViewer,
      fullPage = _ref6.fullPage,
      t = _ref6.t,
      actionHandler = _ref6.actionHandler;
    return {
      action: async () => {
        if (!msid || !siteName) {
          actionHandler == null || actionHandler({
            result: EntriFlowStatus.manual,
            externalViewer,
            domainName
          });
          return;
        }
        const result = await entriConnectAction({
          domainName,
          msid,
          siteName,
          fullPage,
          t
        });
        if (result) {
          actionHandler == null || actionHandler({
            result: result.status,
            externalViewer,
            domainName,
            assigningSiteId: msid
          });
        }
      },
      StatusComponent: StatusesModule.SDK.Components.SubdomainRootIsTaken
    };
  },
  rootDomainIsConnectedByPointing: _ref7 => {
    let domainName = _ref7.domainName,
      msid = _ref7.msid,
      siteName = _ref7.siteName,
      externalViewer = _ref7.externalViewer,
      fullPage = _ref7.fullPage,
      t = _ref7.t,
      actionHandler = _ref7.actionHandler;
    return {
      action: async () => {
        if (!msid || !siteName) {
          actionHandler == null || actionHandler({
            result: EntriFlowStatus.manual,
            externalViewer,
            domainName
          });
          return;
        }
        const result = await entriConnectAction({
          domainName,
          msid,
          siteName,
          fullPage,
          t
        });
        if (result) {
          actionHandler == null || actionHandler({
            result: result.status,
            externalViewer,
            domainName,
            assigningSiteId: msid
          });
        }
      },
      StatusComponent: StatusesModule.SDK.Components.SubdomainRootIsTaken
    };
  },
  externalViewerConnectSubdomainNotAllowed: () => ({
    StatusComponent: StatusesModule.SDK.Components.ExternalViewerSubdomainNotAllowed
  }),
  externalViewerPurchaseSubdomainNotAllowed: () => ({
    StatusComponent: StatusesModule.SDK.Components.ExternalViewerSubdomainNotAllowed
  }),
  externalViewerAssignSubdomainNotAllowed: () => ({
    StatusComponent: StatusesModule.SDK.Components.ExternalViewerSubdomainNotAllowed
  }),
  externalViewerPointingDomain: () => ({
    StatusComponent: StatusesModule.SDK.Components.ExternalViewerPointingDomain
  }),
  notSupportedTld: _ref8 => {
    let domainName = _ref8.domainName;
    return {
      StatusComponent: () => {
        return /*#__PURE__*/React.createElement(InvalidDomain, {
          domainName: domainName
        });
      }
    };
  },
  notSupportedTldRegional: _ref9 => {
    let domainName = _ref9.domainName;
    return {
      StatusComponent: () => {
        return /*#__PURE__*/React.createElement(InvalidDomain, {
          domainName: domainName
        });
      }
    };
  },
  alreadyAssigned: _ref0 => {
    let domainName = _ref0.domainName,
      siteName = _ref0.siteName,
      actionHandler = _ref0.actionHandler,
      externalViewer = _ref0.externalViewer,
      msid = _ref0.msid;
    const alreadyAssigned = ModalsModule.internals.domainsActionsModalsController.alreadyAssigned;
    const _getPremiumEssentials4 = getPremiumEssentials(),
      httpClient = _getPremiumEssentials4.httpClient;
    const canConnectOrBindReq = DomainsApiClient.query.canConnectOrBindDomainSuite({
      httpClient: httpClient,
      request: {
        domain: domainName,
        msid: ''
      }
    });
    return {
      action: async () => {
        var _result$assignedSite;
        const result = await canConnectOrBindReq;
        alreadyAssigned.show({
          handleClose: () => {},
          handleReassign: () => {
            alreadyAssigned.hide();
            actionHandler == null || actionHandler({
              domainName,
              assigningSiteId: msid,
              result: 'alreadyAssigned',
              externalViewer,
              siteName
            });
          },
          assignedSiteName: result == null || (_result$assignedSite = result.assignedSite) == null ? void 0 : _result$assignedSite.siteName,
          assigningSiteName: siteName,
          domain: domainName
        });
      },
      autoInvoke: true
    };
  },
  alreadyAssignedToThisSite: _ref1 => {
    let actionHandler = _ref1.actionHandler,
      externalViewer = _ref1.externalViewer,
      msid = _ref1.msid,
      domainName = _ref1.domainName,
      siteName = _ref1.siteName;
    return {
      action: async () => {
        actionHandler == null || actionHandler({
          result: 'alreadyAssignedToThisSite',
          externalViewer,
          assigningSiteId: msid,
          domainName,
          siteName
        });
      },
      autoInvoke: true
    };
  },
  floatingDomain: _ref10 => {
    let actionHandler = _ref10.actionHandler,
      externalViewer = _ref10.externalViewer,
      domainName = _ref10.domainName,
      msid = _ref10.msid,
      siteName = _ref10.siteName;
    return {
      action: async () => {
        actionHandler == null || actionHandler({
          result: 'floatingDomain',
          domainName,
          assigningSiteId: msid,
          externalViewer,
          siteName
        });
      },
      autoInvoke: true
    };
  },
  languageCodeSubdomain: _ref11 => {
    let domainName = _ref11.domainName;
    const languageCodeSubdomain = ModalsModule.internals.domainsActionsModalsController.languageCodeSubdomain;
    return {
      action: async () => {
        languageCodeSubdomain.show({
          domain: domainName
        });
      },
      autoInvoke: true
    };
  },
  purchaseRootDomainIsRequired: _ref12 => {
    let domainName = _ref12.domainName,
      actionHandler = _ref12.actionHandler,
      props = _objectWithoutPropertiesLoose(_ref12, _excluded);
    const _parseDomain2 = parseDomain(domainName),
      main = _parseDomain2.main;
    const _parseDomain3 = parseDomain(main),
      formattedInput = _parseDomain3.formattedInput;
    return {
      action: async () => {
        const msid = props.msid;
        if (actionHandler) {
          await actionHandler({
            result: undefined,
            domainName: formattedInput,
            ...props
          });
          return;
        }
        const viewMode = DomainSearchSuiteModule.SDK.domainSearchSuiteStore.getStore().viewMode;
        const url = urls.getDomainUrl({
          domainName: formattedInput,
          msid,
          referralAdditionalInfo: viewMode || 'domains-gate'
        });
        window.open(url, '_self');
      },
      StatusComponent: _ref13 => {
        let action = _ref13.action;
        return /*#__PURE__*/React.createElement(StatusesModule.SDK.Components.PurchaseRootIsRequired, _extends({}, props, {
          action: action,
          domainName: formattedInput
        }));
      }
    };
  },
  upgradeRequirePurchaseSubdomain: _ref14 => {
    let domainName = _ref14.domainName,
      props = _objectWithoutPropertiesLoose(_ref14, _excluded2);
    const _parseDomain4 = parseDomain(domainName),
      main = _parseDomain4.main;
    const _parseDomain5 = parseDomain(main),
      formattedInput = _parseDomain5.formattedInput;
    return {
      action: async () => {
        const viewMode = DomainSearchSuiteModule.SDK.domainSearchSuiteStore.getStore().viewMode;
        const msid = props.msid,
          siteName = props.siteName;
        if (!msid || !siteName) {
          return;
        }
        await urls.upgradeSplitPage({
          domainName: formattedInput,
          metaSiteId: msid,
          referralAdditionalInfo: viewMode || 'domain-search-gate'
        });
      },
      StatusComponent: StatusesModule.SDK.Components.PurchaseRootIsRequired
    };
  },
  upgradeRequireAssign: _ref15 => {
    let actionHandler = _ref15.actionHandler,
      params = _objectWithoutPropertiesLoose(_ref15, _excluded3);
    return {
      action: async () => {
        if (actionHandler) {
          await actionHandler({
            result: undefined,
            ...params
          });
          return;
        }
        await upgradeModalAction(params)();
      },
      autoInvoke: true
    };
  },
  upgradeRequireConnect: _ref16 => {
    let actionHandler = _ref16.actionHandler,
      params = _objectWithoutPropertiesLoose(_ref16, _excluded4);
    return {
      action: async () => {
        if (actionHandler) {
          await actionHandler({
            result: undefined,
            ...params
          });
          return;
        }
        await upgradeModalAction(params)();
      },
      StatusComponent: _ref17 => {
        let props = _extends({}, (_objectDestructuringEmpty(_ref17), _ref17));
        const _parseDomain6 = parseDomain(params.domainName),
          subdomain = _parseDomain6.subdomain;
        return subdomain ? /*#__PURE__*/React.createElement(StatusesModule.SDK.Components.SubdomainRootIsTaken, props) : /*#__PURE__*/React.createElement(StatusesModule.SDK.Components.DomainIsTaken, props);
      },
      autoInvoke: params.autoInvoke
    };
  },
  upgradeRequireTransferIn: params => ({
    action: upgradeModalAction(params),
    StatusComponent: StatusesModule.SDK.Components.DomainIsTaken,
    autoInvoke: params.autoInvoke
  }),
  upgradeRequirePurchase: _ref18 => {
    let domainName = _ref18.domainName,
      msid = _ref18.msid,
      actionHandler = _ref18.actionHandler,
      props = _objectWithoutPropertiesLoose(_ref18, _excluded5);
    return {
      action: async () => {
        if (!msid) {
          return;
        }
        if (actionHandler) {
          await actionHandler({
            result: undefined,
            domainName,
            msid,
            ...props
          });
          return;
        }
        const viewMode = DomainSearchSuiteModule.SDK.domainSearchSuiteStore.getStore().viewMode;
        await urls.upgradeSplitPage({
          domainName,
          metaSiteId: msid,
          referralAdditionalInfo: viewMode || 'domain-search-gate'
        });
      }
    };
  }
};
//# sourceMappingURL=domainSearchErrorStatuses.js.map